'use strict';

module.exports = function toJson() {
  return JSON.stringify(this.items);
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/toJson.js
// module id = 1280
// module chunks = 2